import { render, staticRenderFns } from "./CollectResourseItem.vue?vue&type=template&id=11d786ab&scoped=true"
import script from "./CollectResourseItem.vue?vue&type=script&lang=js"
export * from "./CollectResourseItem.vue?vue&type=script&lang=js"
import style0 from "./CollectResourseItem.vue?vue&type=style&index=0&id=11d786ab&prod&lang=less"
import style1 from "./CollectResourseItem.vue?vue&type=style&index=1&id=11d786ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d786ab",
  null
  
)

export default component.exports